import { getDarkWords } from "@/api/home";
import { ReactComponent as BrandOptionsIcon } from "@/assets/brand_options.svg";
import { ReactComponent as CameraIcon, default as camera } from "@/assets/camera.svg";
// import cart from "@/assets/icon/tabbar_cart.png";
import { default as VSwiper } from "@/components/v-swiper";
import { useCommonContext } from "@/utils/context/common";
import { default as useNavigation } from "@/utils/useNavigate";
import { default as React, useEffect, useRef, useState } from "react";
import styles from "./SearchBar.module.less";

const SearchBar: React.FC<{ homeGrayVersion: string }> = ({ homeGrayVersion }) => {
  const { skin, getSkinByKey, cartNum } = useCommonContext();
  const [darkWords, setDarkWords] = useState<any[]>([]);
  const currentDarkWord = useRef<any>(null);
  const { navigate } = useNavigation();
  useEffect(() => {
    getDarkWords().then(data => {
      setDarkWords(data?.darkList ?? []);
    });
  }, []);

  const navigateTo = (url: string) => {
    navigate({
      h5Options: {
        url,
      },
    });
  };

  const toSearchPage = (withSearchWords?: boolean, openCamera?: boolean) => {
    const nSearch = localStorage.getItem("_n_search") || "";
    let url = "/#/mixSearch";
    if (["true", "1"].includes(nSearch)) {
      console.log("来自首页的搜索关键词", currentDarkWord.current);
      // 跳转到新版搜索页
      url = "/mx-shop-micro/search?timestamp=" + Date.now();
      if (withSearchWords && currentDarkWord.current?.searchWords) {
        url += "&searchWords=" + currentDarkWord.current?.searchWords;
      }
      if (openCamera) {
        url += "&openCamera=true";
      }
    } else if (openCamera) {
      url += "?openCamera=true";
    }
    navigateTo(url);
  };
  if (homeGrayVersion === "") {
    return null;
  }
  if (homeGrayVersion === "1") {
    // 新版本号
    return (
      <div className={styles.container}>
        {/* 左侧：品牌 */}
        <div
          className={styles.brandAreaNew}
          style={{ backgroundColor: getSkinByKey("nagivationBtnBgColor") }}
          onClick={() => navigateTo("/#/brandWall")}>
          <BrandOptionsIcon
            className={styles.brandIcon}
            style={{
              "--svgColor":
                skin?.pageGlobalSkinVO?.navHeaderColor ||
                getSkinByKey("nagivationIconColor") ||
                "#222222",
            }}
          />
          <div
            style={{
              color:
                skin?.pageGlobalSkinVO?.navHeaderColor ||
                getSkinByKey("nagivationIconColor") ||
                "#222222",
            }}
            className={styles.brandText}>
            品牌
          </div>
        </div>

        {/* 中间：输入框 */}
        <div
          className={styles.inputBox}
          style={{
            borderColor:
              skin?.pageGlobalSkinVO?.searchBoxBorderColor ||
              skin?.home?.searchBorderColor ||
              "#ff4747",
            backgroundColor: skin?.pageGlobalSkinVO?.searchBoxBgColor || "#fff",
          }}>
          {/* 相机图标 */}
          <CameraIcon
            className={styles.pictureSearchIcon}
            onClick={() => toSearchPage(false, true)}
            style={{
              "--svgColor": skin?.pageGlobalSkinVO?.searchBoxIconColor || "#222222",
            }}
          />
          <div className={styles.sperator}></div>
          <div className={styles.darkWords} onClick={() => toSearchPage()}>
            <VSwiper
              dataList={darkWords}
              height={29}
              stickyDuration={2000}
              rollingDuration={500}
              onIndexChange={(_, item) => (currentDarkWord.current = item)}
              childRender={item => (
                <div
                  className={styles.darkWord}
                  style={{ color: skin?.pageGlobalSkinVO?.searchBoxKeywordsColor || "#a5a5a5" }}>
                  {item.searchWords}
                </div>
              )}
            />
          </div>
          <div
            className={styles.button}
            onClick={() => toSearchPage(true)}
            style={{
              color:
                skin?.pageGlobalSkinVO?.searchBoxButtonTextColor || skin?.home?.searchBtnTextColor,
              backgroundColor:
                skin?.pageGlobalSkinVO?.searchBoxButtonBgColor || skin?.home?.searchBtnBgColor,
            }}>
            搜索
          </div>
        </div>

        {/* 右侧：购物车
    <div className={styles.cartIconBox} onClick={() => navigateTo("/#/cart")}>
      <img 
        className={styles.cartIcon} 
        src={cart} 
        alt="购物车" 
        style={{ color: getSkinByKey("nagivationIconColor") || "#222222" }}
      />
      {!!cartNum && <div className={styles.numWrap}>{cartNum}</div>}
    </div> */}
      </div>
    );
  }

  return (
    <div className={styles.container}>
      {/* 左侧：输入框 */}
      <div className={styles.inputBox} style={{ borderColor: skin?.home?.searchBorderColor || "" }}>
        <img className={styles.pictureSearchIcon} src={camera} />
        <div className={styles.sperator}></div>
        <div className={styles.darkWords} onClick={() => toSearchPage()}>
          <VSwiper
            dataList={darkWords}
            height={29}
            stickyDuration={2000}
            rollingDuration={500}
            onIndexChange={(_, item) => (currentDarkWord.current = item)}
            childRender={item => <div className={styles.darkWord}>{item.searchWords}</div>}
          />
        </div>
        <div
          className={styles.button}
          onClick={() => toSearchPage(true)}
          style={{
            color: skin?.home?.searchBtnTextColor,
            backgroundColor: skin?.home?.searchBtnBgColor,
          }}>
          搜索
        </div>
      </div>

      {/* 右侧：品牌 */}
      <div
        className={styles.brandArea}
        style={{ backgroundColor: getSkinByKey("nagivationBtnBgColor") }}
        onClick={() => navigateTo("/#/brandWall")}>
        <BrandOptionsIcon
          className={styles.brandIcon}
          style={{ "--svgColor": getSkinByKey("nagivationIconColor") || "#222222" }}
        />
        <div style={{ color: getSkinByKey("nagivationIconColor") }} className={styles.brandText}>
          品牌
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
